import AboutUsModule from 'components/about-us/AboutUsModule';
import AboutUsSiteContainer from 'components/about-us/AboutUsSiteContainer';
import AboutUsSiteInnerContainer from 'components/about-us/AboutUsSiteInnerContainer';
import ImageWithText from 'components/common/ImageWithText';
import RoundedButton from 'components/RoundedButton';
import { ASSET_PREFIX } from 'utils/constants';
import { DaymadeDesignSystemPreviewComponentInfo } from '../';

const ComponentPreview = () => {
  return (
    <AboutUsModule background={'grey'}>
      <AboutUsSiteContainer>
        <div style={{ marginBottom: 24 }}>
          <h3 className="aboutUsTypographyHeaderLarge">Image With Text</h3>
          <p>
            <>
              An component with a boxed image with text next to it, being used
              on several components on the dashboard page. Customisable with a
              title and child components in the right-hand side text section and
              allowing for a child component to overlay the image.
            </>
          </p>
        </div>
        <AboutUsSiteInnerContainer background="white" borderRadius withPadding>
          <div style={{ display: 'grid', gap: '16px' }}>
            <ImageWithText
              imageSrc="https://daymade-prize-assets.s3.amazonaws.com/6683aae6-66a9-4fd6-a60e-d8225bdc19fa.jpg"
              title="Image with title"
            />
            <ImageWithText
              imageSrc="https://daymade-prize-assets.s3.amazonaws.com/6683aae6-66a9-4fd6-a60e-d8225bdc19fa.jpg"
              title="Image with title and chevron"
              cta="chevron"
            />
            <ImageWithText
              imageSrc={`${ASSET_PREFIX}/images/common/add-prize.svg`}
              textChildren={
                <>
                  <p>Elements in textChildren will fill the remaining width</p>
                  <RoundedButton colorStyle="OutlineDark" onClick={() => {}}>
                    ADD PRIZE
                  </RoundedButton>
                </>
              }
            />
            <ImageWithText
              imageSrc={`${ASSET_PREFIX}/images/common/add-prize.svg`}
              textChildren={
                <>
                  <p>
                    Elements in textChildren will fill the remaining width, or
                    they can use align-self: flex-start
                  </p>
                  <RoundedButton
                    style={{ alignSelf: 'flex-start' }}
                    colorStyle="OutlineDark"
                    onClick={() => {}}
                  >
                    ADD PRIZE
                  </RoundedButton>
                </>
              }
            />
            <ImageWithText
              imageSrc={`${ASSET_PREFIX}/images/common/add-prize.svg`}
              textChildren={
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 8,
                    alignItems: 'flex-start',
                  }}
                >
                  <p>
                    This is some text that describes what the button below
                    should do. The text can be quite long, so it will wrap onto
                    two lines if necessary. The button below is in another
                    flex-container, so doesn't go full width
                  </p>
                  <RoundedButton colorStyle="OutlineDark" onClick={() => {}}>
                    ADD PRIZE
                  </RoundedButton>
                </div>
              }
              cta="chevron"
            />
          </div>
        </AboutUsSiteInnerContainer>
      </AboutUsSiteContainer>
    </AboutUsModule>
  );
};

ComponentPreview.daymadeDesignSystemInfo = {
  name: 'Image With Text',
} as DaymadeDesignSystemPreviewComponentInfo;

export default ComponentPreview;
